var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aqDiv"},[_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","justify-content":"space-between","margin-top":"60px"}},_vm._l((_vm.list),function(item,i){return _c('el-col',{key:i,staticClass:"aqImgDiv",attrs:{"span":5}},[_c('img',{attrs:{"src":item}})])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }